import React, { useContext, useEffect, useState } from "react";
import "./Sidebar.css";
import Logo from "../../assets/logo.jpg";
import { UilSignOutAlt, UilBars } from "@iconscout/react-unicons";
import { motion } from "framer-motion";
import { SidebarData } from "../../Data/Data";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

const SidebarMenu = ({ selectedIndex, setSelectedIndex }) => {
  const [expanded, setExpanded] = useState(true);
  const { user, updateUser, token, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const sidebarVariants = {
    true: { left: "0" },
    false: { left: "-60%" },
  };

  // Function to handle menu item click
  const handleMenuItemClick = (index, path = null) => {
    setSelectedIndex(index);

    // Auto-close sidebar on mobile
    if (window.innerWidth <= 768) {
      setExpanded(false);
    }

    // Navigate if path is provided
    if (path) {
      navigate(path);
    }
  };

  // Handle logout
  const handleLogout = () => {
    if (window.innerWidth <= 768) {
      setExpanded(false);
    }
    logout();
  };

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (window.innerWidth <= 768 && expanded) {
        const sidebar = document.querySelector(".sidebar");
        const bars = document.querySelector(".bars");

        if (
          sidebar &&
          !sidebar.contains(event.target) &&
          bars &&
          !bars.contains(event.target)
        ) {
          setExpanded(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  return (
    <>
      <div
        className="bars"
        style={expanded ? { left: "60%" } : { left: "5%" }}
        onClick={() => setExpanded(!expanded)}
      >
        <UilBars />
      </div>
      <motion.div
        className="sidebar"
        variants={sidebarVariants}
        animate={window.innerWidth <= 768 ? `${expanded}` : ""}
      >
        {/* logo */}
        <Link to="/" className="text-decoration-none">
          <div className="logo">
            <img src={Logo} alt="logo" />
            <span>
              AC<span>ES</span>WA
            </span>
          </div>
        </Link>

        <div className="menu">
          {SidebarData.map((item, index) => (
            <div
              className={
                selectedIndex === index ? "menuItem active" : "menuItem"
              }
              key={index}
              onClick={() => handleMenuItemClick(index)}
            >
              <item.icon />
              <span>{item.heading}</span>
            </div>
          ))}
          {/* signout */}
          <div className="menuItem">
            <UilSignOutAlt onClick={handleLogout} />
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SidebarMenu;
